import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import * as queryString from 'qs';
import Notification from 'SelfServeBuilderResponses/Notification';
import { SelfServeBuilderSidePanelTypes } from 'SelfServeBuilderSidePanel/SelfServeBuilderSidePanelConstants';
import ToggleButton from 'SelfServeBuilder/ToggleButton';
import { setIsRecipientPreviewModalVisible, setNotification } from 'SelfServeBuilder/SelfServeBuilderActions';
import { hideAllPreviewTips } from 'SelfServeTooltipTour/TooltipTourActions';
import SelfServeTooltipTourConstants from 'SelfServeTooltipTour/TooltipTourConstants';
import BackToOriginalDocumentLink from './BackToOriginalDocumentLink';
import BackToTemplatesButton from './BackToTemplatesButton';
import SelfServeBuilderToolbarButtons from './SelfServeBuilderToolbarButtons';

class SelfServeBuilderToolbar extends React.PureComponent {
  constructor(props) {
    super(props);

    this.clearNotification = this.clearNotification.bind(this);
    this.showRecipientPreview = this.showRecipientPreview.bind(this);

    const queryParams = queryString.parse(window.location.search, { ignoreQueryPrefix: true });
    const showBackToOriginalDocumentLink = queryParams.backToOriginalDocument || false;

    this.state = {
      showBackToOriginalDocumentLink: !!showBackToOriginalDocumentLink,
    };
  }

  componentDidMount() {
    const queryParams = queryString.parse(window.location.search, { ignoreQueryPrefix: true });
    const isDuplicateTemplate = queryParams.duplicate_template;
    if (isDuplicateTemplate) {
      this.props.setNotification('Your template was duplicated.', false);
    }
    if (this.props.isSampleState && !this.props.isPreviewAutoOpenDisabled) {
      this.props.setIsRecipientPreviewModalVisible(true);
    }
  }

  showRecipientPreview() {
    const {
      activeTooltipIndex,
      isTourDisplayed,
    } = this.props;

    window._track('Preview', 'Template Builder');
    this.props.setIsRecipientPreviewModalVisible(true);

    const hidePreviewTourTooltips = isTourDisplayed &&
      (activeTooltipIndex === SelfServeTooltipTourConstants.PREVIEW_BUTTON_TOOLTIP_IDX);

    if (hidePreviewTourTooltips) {
      this.props.hideAllPreviewTips();
    }
  }

  clearNotification() {
    this.props.setNotification(null, false);
  }

  render() {
    const {
      isOpenPostBuilderSidePanel,
      isPreviewMode,
      isSampleState,
    } = this.props;

    return (
      <div className="builder-buttons-wrapper">
        <div className="notification-container">
          {this.props.notification && (
            <Notification
              notification={this.props.notification}
              isError={this.props.isNotificationError}
              onClick={this.clearNotification}
            />
          )}
        </div>
        {(this.props.showBackToOriginalDocumentLink || this.state.showBackToOriginalDocumentLink) &&
          <BackToOriginalDocumentLink />
        }
        <div className="button-container builder-buttons-container">
          Viewing As
          <ToggleButton
            additionalClassNames={this.props.isSampleState ? 'sample-document-state' : ''}
            isLeftToggled={!this.props.isRecipientPreviewModalVisible}
            isRightToggled={this.props.isRecipientPreviewModalVisible}
            leftText="Sender (You)"
            onClickRight={this.showRecipientPreview}
            rightText="Recipient"
          />
          <BackToTemplatesButton
            buttonText="END DEMO"
            isOpenPostBuilderSidePanel={isOpenPostBuilderSidePanel}
            isSampleState={isSampleState}
          />
          <SelfServeBuilderToolbarButtons isPreviewMode={isPreviewMode} />
        </div>
      </div>
    );
  }
}

SelfServeBuilderToolbar.propTypes = {
  activeTooltipIndex: PropTypes.number.isRequired,
  isTourDisplayed: PropTypes.bool.isRequired,
  hideAllPreviewTips: PropTypes.func.isRequired,
  isNotificationError: PropTypes.bool.isRequired,
  isOpenPostBuilderSidePanel: PropTypes.bool,
  isPreviewAutoOpenDisabled: PropTypes.bool,
  isPreviewMode: PropTypes.bool,
  isRecipientPreviewModalVisible: PropTypes.bool,
  isSampleState: PropTypes.bool.isRequired,
  notification: PropTypes.string.isRequired,
  showBackToOriginalDocumentLink: PropTypes.bool,
  setIsRecipientPreviewModalVisible: PropTypes.func,
  setNotification: PropTypes.func.isRequired,
};

SelfServeBuilderToolbar.defaultProps = {
  isOpenPostBuilderSidePanel: false,
  isPreviewAutoOpenDisabled: true,
  isPreviewMode: false,
  isRecipientPreviewModalVisible: false,
  setIsRecipientPreviewModalVisible: () => null,
  showBackToOriginalDocumentLink: false,
};

const mapStateToProps = ({
  SelfServeBuilderReducer,
  SelfServeBuilderSidePanelHandler,
  TooltipTourReducer,
}) => ({
  activeTooltipIndex: TooltipTourReducer.activeTooltipIndex,
  isNotificationError: SelfServeBuilderReducer.isNotificationError,
  isSampleState: SelfServeBuilderReducer.isSampleState,
  isTourDisplayed: TooltipTourReducer.isTourDisplayed,
  notification: SelfServeBuilderReducer.notification,
  isOpenPostBuilderSidePanel: SelfServeBuilderSidePanelHandler[
    SelfServeBuilderSidePanelTypes.POST_BUILDER
  ].isOpen,
  isRecipientPreviewModalVisible: SelfServeBuilderReducer.isRecipientPreviewModalVisible,
});

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    hideAllPreviewTips,
    setNotification,
    setIsRecipientPreviewModalVisible,
  }, dispatch)
);

export const SelfServeBuilderToolbarWithRedux = connect(
  mapStateToProps,
  mapDispatchToProps)(SelfServeBuilderToolbar);

export default SelfServeBuilderToolbarWithRedux;



// WEBPACK FOOTER //
// ./src-react/SelfServeBuilder/SelfServeBuilderToolbar/index.jsx